import type { IMixParlayBetSlip } from '@/interface/betSlip';

export function generateComboParlayCombination(arr: number[], size: number): number[][] {
    const result: number[][] = [];
    function createTree(rootArr: number[], remainArr: number[], remainSize: number) {
        if (remainArr.length <= 0 || remainSize === 0) {
            result.push(rootArr);
            return;
        }
        for (let i = 0; i <= remainArr.length - remainSize; i++) {
            const root = remainArr[i];
            const other = remainArr.slice(i + 1);
            createTree(rootArr.concat(root), other, remainSize - 1);
        }
    }
    createTree([], arr, size);
    return result;
}

export function getComboTotalOdds(comboOdds: Record<number, number[][]>): Record<number, number> {
    return Object.keys(comboOdds).reduce<Record<number, number>>((acc1, fold) => {
        const foldNum = Number(fold);
        acc1[foldNum] = comboOdds[foldNum].reduce((acc2: number, price: number[]) => acc2 + getTotalOdds(price), 0);
        return acc1;
    }, {});
}

export function isValidComboBet(betSlip: IMixParlayBetSlip, isValidMpSubBetsCount = false) {
    return betSlip.min > 0
        && betSlip.max > 0
        && betSlip.selectedCombo.length > 0
        && isValidMpSubBetsCount;
}

export function getTotalOdds(prices: number[]) {
    if (prices.length === 0) {
        return 0;
    }
    return Math.floor(prices.reduce((totalOdds, odd) => (totalOdds * odd), 1) * 1000) / 1000;
}

export function getTotalBetCount(selectedCombo: number[], comboOdds: Record<number, number[][]>) {
    return selectedCombo.reduce((total, combo) => total + (comboOdds[combo]?.length ?? 0), 0);
}

export function getTotalPayout(selectedCombo: number[], comboTotalOdds: Record<number, number>, stake: number) {
    return selectedCombo.reduce((acc, cur) => acc + ((comboTotalOdds[cur] ?? 0) * stake), 0);
}
